"use client";

import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Footer() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  return <footer ref={ref} className={`bg-background border-t border-border py-8 transition-all duration-[var(--duration-fast)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
      <div className="container mx-auto px-4 max-w-7xl">
        <div className="flex flex-col md:flex-row md:justify-between md:items-start gap-8">
          {}
          <div className="flex flex-col gap-4">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1515534/img/oryx_fleet_logo.png" alt="Oryx Fleet LLC" className="h-7" />
            
            <p className="text-xs text-muted-foreground">
              &copy; {new Date().getFullYear()} Oryx Fleet LLC. All rights reserved.
            </p>

            <div className="flex flex-col gap-2 text-sm text-muted-foreground">
              <p>30 N Gould St Ste R, Sheridan, WY 82801</p>
              <p>(888) 218-8355</p>
              <p>dispatch@oryxfleet.com</p>
            </div>
          </div>

          {}
          <nav className="flex flex-col md:flex-row gap-4 md:gap-6 text-sm">
            <Link to="/LegalPage#privacy-policy" className="text-foreground-light hover:text-primary transition-all duration-[var(--duration-medium)] hover:-translate-y-0.5 hover:shadow-soft inline-block">
              Privacy Policy
            </Link>
            <Link to="/LegalPage#terms-conditions" className="text-foreground-light hover:text-primary transition-all duration-[var(--duration-medium)] hover:-translate-y-0.5 hover:shadow-soft inline-block">
              Terms & Conditions
            </Link>
            <Link to="/LegalPage#refund-cancellation" className="text-foreground-light hover:text-primary transition-all duration-[var(--duration-medium)] hover:-translate-y-0.5 hover:shadow-soft inline-block">
              Refund & Cancellation
            </Link>
          </nav>
        </div>
      </div>
    </footer>;
}